import styled from 'styled-components';

export default styled.div``;

export const CardTopSC = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  .sub-text-wrap {
    width: 100%;
  }
  p {
    padding-top: 16px;
    max-width: 500px;
  }
`;
